import _each from "lodash/each";
import _concat from "lodash/concat";
import News from "~/js/brands/news";
import { storefrontApi } from '~/js/api/storefrontApi';
import { renderArticleCards } from '~/js/components/articleCard';

export default class ShopDetail {

    constructor() {

        /**
         * Global
         */
        this.shopDetailData = undefined
        this.$shopDetailContent = $('#shop-detail-content')

        /**
         * Map style
         */
        const STYLE_OPTION = [
        {
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "elementType": "geometry",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "stylers": [
            {
                "visibility": "simplified"
            }
            ]
        },
        {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "administrative.neighborhood",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.province",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "poi.attraction",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "poi.park",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
            {
                "gamma": "1.00"
            },
            {
                "visibility": "on"
            },
            {
                "saturation": "100"
            },
            {
                "hue": "#0053ff"
            }
            ]
        },
        {
            "featureType": "transit.station",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.bus",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "transit.station.rail",
            "elementType": "labels.text",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "weight": 0.5
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#eeeeee"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
            {
                "color": "#b4d4e1"
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#c4e3ec"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
            {
                "color": "#e9e9e9"
            },
            {
                "visibility": "on"
            }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
            {
                "color": "#cfcece"
            }
            ]
        },
        {
            "featureType": "administrative.country",
            "stylers": [
            {
                "visibility": "off"
            }
            ]
        },
        {
            "featureType": "administrative.locality",
            "stylers": [
            {
                "visibility": "on"
            }
            ]
        }
        ]

        /**
         * Check shop exists
         */
        if (shopMasterObjectData) {
            let params = this.getParams()
            this.shopDetailData = shopMasterObjectData.find(shop => shop.shop_code == params['shop_code'])
        }

        this.render()
        window.initMap = this.initMap
    }

    render(params) {
        /**
         * Render Content
         */
        if (typeof this.shopDetailData !== "undefined") {
            const template = _.template($('[data-js="shop-detail__template"]').html())
            this.$shopDetailContent.html(template({
            data: this.shopDetailData
            }))
            $('.p-carousel__list').slick({infinite: true, arrows: false})
            document.title = this.shopDetailData.name+" - "+document.title
            //pankuzu
            const breadcrumb = document.querySelector(".breadcrumb__inner")
            breadcrumb.insertAdjacentHTML('beforeend', `<a href="/pages/storesdetail?shop_code=${this.shopDetailData.shop_code}" class="current" aria-current="page">
            <span>${this.shopDetailData.name}</span>
            </a>`)

            //旗艦店以外はニュースはなし
            const section = document.getElementById("storenews");
            if(!this.shopDetailData.is_flagship){
                section.remove()
                return false;
            }
            //ニュースの取得
            let brandTags = [];
            for (let i = 1; i <= 20; i++){
                if(this.shopDetailData['brand'+i] !== undefined && this.shopDetailData['brand'+i] != ""){
                    if(this.shopDetailData['brand'+i] == "ISSEY MIYAKE"){
                        brandTags.push(handleize("ISSEY MIYAKE Brand"));
                    } else if (this.shopDetailData['brand'+i] == "HOMME PLISSÉ ISSEY MIYAKE"){
                        brandTags.push("HOMME PLISSÉ ISSEY MIYAKE");
                    } else {
                        brandTags.push(handleize(this.shopDetailData['brand'+i]));
                    }
                }
            }
            // Gallery
            if(this.shopDetailData['gallery'] != ""){
                brandTags.push(handleize(this.shopDetailData['gallery']));
            }
            // 店舗
            if(this.shopDetailData['shop_code'] != ""){
                brandTags.push('shop_code_'+handleize(this.shopDetailData['shop_code']));
            }

            this.loadNewsArticles(section, brandTags);

        } else {
            const template = _.template($('[data-js="shop-detail-not-found__template"]').html())
            this.$shopDetailContent.html(template)
            setTimeout(function() {
                location.href = 'https://httpscloning-isseymiyake-com.myshopify.com/pages/stores';
            }, 500);
        }
    }

    /**
     * Retrieve and display news articles
     * @param {HTMLElement} section - News section element
     * @param {string[]} brandTags - Array of brand tags
     */
    async loadNewsArticles(section, brandTags) {
        // Hide section when token is not set
        if (!window.__STOREFRONT_ACCESS_TOKEN__) {
            console.warn('Storefront API token is not configured');
            section.remove();
            return;
        }

        try {
            // Get articles from GraphQL API (in order of publication date)
            const articles = await storefrontApi.getArticlesByTags(brandTags, 32);

            // Remove section if there are no articles
            if (articles.length === 0) {
                section.remove();
                return;
            }

            // Generate article card HTML (add hidden class to articles exceeding 8)
            const html = renderArticleCards(articles, 8);

            // Insert into DOM
            section.querySelector('._cellContainer').innerHTML = html;
            section.querySelector('._cellContainer').classList.add('loaded');

            // Initialize News component
            this.news = new News('.js-news');

        } catch (error) {
            console.error('Failed to load news articles:', error);
            section.remove();
        }
    }

    /**
     * InitMap for Google
     */
    initMap() {
        let defaultOptions = {
        styles: STYLE_OPTION,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        mapTypeControl: false,
        center: new google.maps.LatLng(
                parseFloat(this.shopDetailData.latitude),
                parseFloat(this.shopDetailData.longitude)
            ),
            zoom: 16
        }

        // set Marker
        new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(this.shopDetailData.latitude), parseFloat(this.shopDetailData.longitude)),
        map: new google.maps.Map(document.getElementById("map"), defaultOptions),
        icon: {
            url: this.getAssetByName('img_cluster_ss.png'),
            size: new google.maps.Size(24, 30),
        }
        })
    }

    /**
     * @returns {*}
     */
    getParams() {
        let result = []
        let url = document.location.href
        let qs = url.substring(url.indexOf('?') + 1).split('&')

        for (let i = 0; i < qs.length; i++) {
        qs[i] = qs[i].split('=')
        result[qs[i][0]] = decodeURIComponent(qs[i][1])
        }

        return result
    }

    /**
     * @param fileName
     */
    getAssetByName(fileName) {
        if (shopListAsset) {
        return shopListAsset.replace('FILE', fileName)
        }
    }
}
